var React = require('react');

function ArrowR (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M197.87,104.31l.2-.2a6.77,6.77,0,0,0-.2-9.67L134.52,32.07a7.1,7.1,0,0,0-10,0,7.2,7.2,0,0,0,0,9.87l51.32,50.33H6.83a7,7,0,0,0,0,14h169L124.7,156.61l-1,1a7,7,0,0,0,1,9.87,7.33,7.33,0,0,0,10-1Z","transform":"translate(0 -30)"}));
}

ArrowR.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 200 139"};

module.exports = ArrowR;

ArrowR.default = ArrowR;
